import { NgRedux, select } from '@ptl/angular-redux-store';
import { Component, OnInit, ViewChild, Input, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { StateStructure } from '@ptl/state';
import { Observable } from 'rxjs';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PRODUCER_PROSPECT_PAGINATOR_REDUCER_NAME, setPaginationData } from '../../../reducers/producer-prospect-paginator.reducer';

@Component({
    selector: 'app-producer-prospect-paginator',
    templateUrl: './producer-prospect-paginator.component.html',
    styleUrls: ['./producer-prospect-paginator.component.scss'],
    standalone: false
})
export class ProducerProspectPaginatorComponent implements OnInit, AfterViewInit {

  @Input() private pageSizeOptions: string = '6, 12, 18, 30, 60';
  formattedPageSizeOptions: number[];
  pageSize: number = 60;
  totalLength: number;

  @select(['componentStates', PRODUCER_PROSPECT_PAGINATOR_REDUCER_NAME, 'totalLength']) totalLength$: Observable<string>;
  @ViewChild('producerProspectPaginator') paginator: MatPaginator;

  constructor(
    private ngRedux: NgRedux<StateStructure>,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  ngOnInit(): void {

    this.formattedPageSizeOptions = (() => {
      try {
        const regex = new RegExp(/ /, 'g');
        const trimmed = this.pageSizeOptions.replace(regex, '');
        const split = trimmed.split(',');
        const array = split.map((pageSize: string) => parseInt(pageSize, 10));
        return array;
      } catch (e) {
        console.log('No valid paginator setting available, hiding (Hint: "1, 2, 10, 50")');
      }
    })();

    this.totalLength$.subscribe(value => {
      this.totalLength = parseInt(value, 10);
    });
  }

  ngAfterViewInit(): void {
    const options = this.formattedPageSizeOptions;
    if (options) {
      const lastIndex = options.length - 1;
      this.ngRedux.dispatch(setPaginationData(0, options[0]));
      this.pageSize = options[0];
    }
  }

  change(event: { length: number, pageIndex: number, pageSize: number, previousPageIndex: number }) {
    this.ngRedux.dispatch(setPaginationData(event.pageIndex, event.pageSize));
  }
}
